/* eslint-disable */
/*!
 * froala_editor v4.0.6 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(require('froala-editor'))
    : typeof define === 'function' && define.amd
    ? define(['froala-editor'], factory)
    : factory(global.FroalaEditor);
})(this, function (FE) {
  'use strict';

  FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  Object.assign(FE.DEFAULTS, {
    paragraphFormat: {
      N: 'Normal',
      H1: 'Heading 1',
      H2: 'Heading 2',
      H3: 'Heading 3',
      H4: 'Heading 4',
    },
    paragraphFormatSelection: false,
    paragraphDefaultSelection: 'Paragraph Format',
  });

  FE.PLUGINS.paragraphFormat = function (editor) {
    var $ = editor.$;
    /**
     * Style content inside LI when LI is selected.
     * This case happens only when the LI contains a nested list or when it has no block tag inside.
     */

    function _styleLiWithoutBlocks($li, val) {
      var defaultTag = editor.html.defaultTag(); // If val is null or default tag already do nothing.

      if (val && val.toLowerCase() != defaultTag) {
        // Deal with nested lists.
        if ($li.find('ul, ol').length > 0) {
          var $el = $('<' + val + '>');
          $li.prepend($el);
          var node = editor.node.contents($li.get(0))[0];

          while (node && ['UL', 'OL'].indexOf(node.tagName) < 0) {
            var next_node = node.nextSibling;
            $el.append(node);
            node = next_node;
          }
        } // Wrap list content.
        else {
          $li.html('<' + val + '>' + $li.html() + '</' + val + '>');
        }
      }
    }
    /**
     * Style content inside LI.
     */

    function _styleLiWithBlocks($blk, val) {
      var defaultTag = editor.html.defaultTag(); // Prepare a temp div.

      if (!val || val.toLowerCase() == defaultTag) val = 'div class="fr-temp-div"';
      $blk.replaceWith($('<' + val + '>').html($blk.html()));
    }
    /**
     * Style content inside TD.
     */

    function _styleTdWithBlocks($blk, val) {
      var defaultTag = editor.html.defaultTag(); // Prepare a temp div.

      if (!val)
        val =
          'div class="fr-temp-div"' +
          (editor.node.isEmpty($blk.get(0), true) ? ' data-empty="true"' : ''); // Return to the regular case. We don't use P inside TD/TH.

      if (val.toLowerCase() == defaultTag) {
        // If node is not empty, then add a BR.
        if (!editor.node.isEmpty($blk.get(0), true)) {
          $blk.append('<br/>');
        }

        $blk.replaceWith($blk.html());
      } // Replace with the new tag.
      else {
        $blk.replaceWith($('<' + val + '>').html($blk.html()));
      }
    }
    /**
     * Basic style.
     */

    function _style($blk, val) {
      if (!val)
        val =
          'div class="fr-temp-div"' +
          (editor.node.isEmpty($blk.get(0), true) ? ' data-empty="true"' : ''); //1708 Paragraph Format

      if (val == 'H1' || val == 'H2' || val == 'H3' || val == 'H4' || val == 'H5') {
        var $checkstyle = editor.node.attributes($blk.get(0)); // https://github.com/froala-labs/froala-editor-js-2/issues/3867

        if ($checkstyle.indexOf('font-size:') > -1) {
          $blk.replaceWith(
            $(
              '<' +
                val +
                ' ' +
                editor.node.attributes($blk.get(0)).replace(/font-size:[0-9]+px;?/, '') +
                '>'
            )
              .html($blk.html())
              .removeAttr('data-empty')
          );
        } else {
          $blk.replaceWith(
            $('<' + val + ' ' + editor.node.attributes($blk.get(0)) + '>')
              .html($blk.html())
              .removeAttr('data-empty')
          );
        }
      } else {
        $blk.replaceWith(
          $('<' + val + ' ' + editor.node.attributes($blk.get(0)) + '>')
            .html($blk.html())
            .removeAttr('data-empty')
        );
      }
    }
    /**
     * Apply style.
     */

    function apply(val) {
      // Normal.
      if (val == 'N') val = editor.html.defaultTag(); // Wrap.

      editor.selection.save();
      editor.html.wrap(true, true, !editor.opts.paragraphFormat.BLOCKQUOTE, true, true);
      editor.selection.restore(); // Get blocks.

      var blocks = editor.selection.blocks(); // Save selection to restore it later.

      editor.selection.save();
      editor.$el.find('pre').attr('skip', true); // Go through each block and apply style to it.

      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].tagName != val && !editor.node.isList(blocks[i])) {
          var $blk = $(blocks[i]); // Style the content inside LI when there is selection right in LI.

          if (blocks[i].tagName == 'LI') {
            _styleLiWithoutBlocks($blk, val);
          } // Style the content inside LI when we have other tag in LI.
          else if (blocks[i].parentNode.tagName == 'LI' && blocks[i]) {
            _styleLiWithBlocks($blk, val);
          } // Style the content inside TD/TH.
          else if (['TD', 'TH'].indexOf(blocks[i].parentNode.tagName) >= 0) {
            _styleTdWithBlocks($blk, val);
          } // Regular case.
          else {
            // https://github.com/froala-labs/froala-editor-js-2/issues/3805
            if (val === 'PRE' && $blk[0].nextSibling === null) {
              var br = $('<br>');
              $blk[0].after(br[0]);
            }

            _style($blk, val);
          }
        }
      } // Join PRE together.

      editor.$el.find('pre:not([skip="true"]) + pre:not([skip="true"])').each(function () {
        $(this)
          .prev()
          .append('<br>' + $(this).html());
        $(this).remove();
      });
      editor.$el.find('pre').removeAttr('skip'); // Unwrap temp divs.

      editor.html.unwrap(); // Restore selection.

      editor.selection.restore();
    }

    function refreshOnShow($btn, $dropdown) {
      var blocks = editor.selection.blocks();

      if (blocks.length) {
        var blk = blocks[0];
        var tag = 'N';
        var default_tag = editor.html.defaultTag();

        if (blk.tagName.toLowerCase() != default_tag && blk != editor.el) {
          tag = blk.tagName;
        }

        $dropdown
          .find('.fr-command[data-param1="' + tag + '"]')
          .addClass('fr-active')
          .attr('aria-selected', true);
      } else {
        $dropdown
          .find('.fr-command[data-param1="N"]')
          .addClass('fr-active')
          .attr('aria-selected', true);
      }
    }

    function refresh($btn) {
      if (editor.opts.paragraphFormatSelection) {
        var blocks = editor.selection.blocks();

        if (blocks.length) {
          var blk = blocks[0];
          var tag = 'N';
          var default_tag = editor.html.defaultTag();

          if (blk.tagName.toLowerCase() != default_tag && blk != editor.el) {
            tag = blk.tagName;
          }

          if (['LI', 'TD', 'TH'].indexOf(tag) >= 0) {
            tag = 'N';
          }

          $btn.find('>span').text(editor.language.translate(editor.opts.paragraphFormat[tag]));
        } else {
          $btn.find('>span').text(editor.language.translate(editor.opts.paragraphFormat.N));
        }
      }
    }

    return {
      apply: apply,
      refreshOnShow: refreshOnShow,
      refresh: refresh,
    };
  }; // Register the font size command.

  FE.RegisterCommand('paragraphFormat', {
    type: 'dropdown',
    displaySelection: function displaySelection(editor) {
      return editor.opts.paragraphFormatSelection;
    },
    defaultSelection: function defaultSelection(editor) {
      return editor.language.translate(editor.opts.paragraphDefaultSelection);
    },
    displaySelectionWidth: 80,
    html: function html() {
      var c = '<ul class="fr-dropdown-list" role="presentation">';
      var options = this.opts.paragraphFormat;

      for (var val in options) {
        if (options.hasOwnProperty(val)) {
          var shortcut = this.shortcuts.get('paragraphFormat.' + val);

          if (shortcut) {
            shortcut = '<span class="fr-shortcut">' + shortcut + '</span>';
          } else {
            shortcut = '';
          }

          c +=
            '<li role="presentation"><' +
            (val == 'N' ? this.html.defaultTag() || 'DIV' : val) +
            ' style="padding: 0 !important; margin: 0 !important; border: 0 !important; background-color: transparent !important; ' +
            (val == 'PRE' || val == 'N' ? 'font-size: 15px' : 'font-weight: bold !important; ') +
            (val == 'H1' ? 'font-size: 2em !important; ' : '') +
            (val == 'H2' ? 'font-size: 1.5em !important; ' : '') +
            (val == 'H3' ? 'font-size: 1.17em !important; ' : '') +
            (val == 'H4' ? 'font-size: 15px !important;' : '') +
            '"  role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="paragraphFormat" data-param1="' +
            val +
            '" title="' +
            this.language.translate(options[val]) +
            '">' +
            this.language.translate(options[val]) +
            '</a></' +
            (val == 'N' ? this.html.defaultTag() || 'DIV' : val) +
            '></li>';
        }
      }

      c += '</ul>';
      return c;
    },
    title: 'Paragraph Format',
    callback: function callback(cmd, val) {
      this.paragraphFormat.apply(val);
    },
    refresh: function refresh($btn) {
      this.paragraphFormat.refresh($btn);
    },
    refreshOnShow: function refreshOnShow($btn, $dropdown) {
      this.paragraphFormat.refreshOnShow($btn, $dropdown);
    },
    plugin: 'paragraphFormat',
  }); // Add the font size icon.

  FE.ICON_TEMPLATES['html'] = '[HTML]';

  FE.DefineIcon('paragraphFormat', {
    HTML: `
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="text" class="svg-inline--fa fa-text" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M448 64.01v64c0 17.69-14.31 32-32 32s-32-14.31-32-32v-32h-128v320h48c17.69 0 32 14.31 32 32s-14.31 31.1-32 31.1h-160c-17.69 0-32-14.31-32-31.1s14.31-32 32-32H192v-320H64v32c0 17.69-14.31 32-32 32s-32-14.31-32-32v-64c0-17.69 14.31-32 32-32h384C433.7 32.01 448 46.33 448 64.01z"></path></svg>
    `,
    template: 'html',
  });
});
